import moment from "moment";
import { IProject, IParamQuery } from "../interface/project";

export const getProjectList = (
  param: IParamQuery | undefined,
  abortController?: AbortController
) => {
  const paramquery = param
    ? `${param.keywords.length > 0 ? `search=${param.keywords}&` : ""}${
        param.createdDate
          ? `created_at=${param.createdDate},${moment().format("YYYY-MM-DD")}&`
          : ""
      }`
    : "";
  return fetch(
    `${process.env.REACT_APP_API_URL}/${process.env.REACT_APP_API_VERSION}/projects?${paramquery}designs=false`,
    {
      method: "GET",
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
        "Content-Type": "application/json",
      },
      signal: abortController?.signal,
    }
  )
    .then((response) => response.json())
    .then((result) => {
      return param && param.status >= 0
        ? {
            ...result,
            data: result.data.filter((rs: any) => rs.status === param.status),
          }
        : result;
    })
    .catch((error) => {
      console.log("error", error);
    });
};

export const getProjectById = (prjId: string) => {
  return fetch(
    `${process.env.REACT_APP_API_URL}/${process.env.REACT_APP_API_VERSION}/projects/${prjId}`,
    {
      method: "GET",
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
        "Content-Type": "application/json",
      },
    }
  )
    .then((response) => response.json())
    .then((result) => result)
    .catch((error) => {
      console.log("error", error);
    });
};

export const postAddProject = (newProject: IProject) => {
  return fetch(
    `${process.env.REACT_APP_API_URL}/${process.env.REACT_APP_API_VERSION}/projects`,
    {
      method: "POST",
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(newProject),
    }
  )
    .then((response) => response.json())
    .then((result) => result)
    .catch((error) => {
      console.log("error", error);
    });
};

export const putEditProject = (newProject: IProject) => {
  const {
    _id,
    created_at,
    created_by,
    updated_at,
    updated_by,
    ...resParamProject
  } = newProject;
  console.log(resParamProject);
  return fetch(
    `${process.env.REACT_APP_API_URL}/${process.env.REACT_APP_API_VERSION}/projects/${_id}`,
    {
      method: "PUT",
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(resParamProject),
    }
  )
    .then((response) => response.json())
    .then((result) => result)
    .catch((error) => {
      console.log("error", error);
    });
};

export const delDeleteProject = (projectId: string) => {
  return fetch(
    `${process.env.REACT_APP_API_URL}/${process.env.REACT_APP_API_VERSION}/projects/${projectId}`,
    {
      method: "DELETE",
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
        "Content-Type": "application/json",
      },
    }
  )
    .then((response) => response)
    .catch((error) => {
      console.log("error", error);
      return error;
    });
};

export const getProjectAggregate = (
  abortController?: AbortController,
  param?: string | null,
  value?: string | number | null
) => {
  return fetch(
    `${process.env.REACT_APP_API_URL}/${
      process.env.REACT_APP_API_VERSION
    }/projects/${param ? `aggregate?${param}=${value}` : "aggregate"}`,
    {
      method: "GET",
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
        "Content-Type": "application/json",
      },
      signal: abortController?.signal,
    }
  )
    .then((response) => response.json())
    .then((result) => result)
    .catch((error) => {
      console.log("error", error);
    });
};

export const getProjectDesignsAggregate = (
  abortController?: AbortController,
  param?: string | null,
  value?: string | number | null
) => {
  return fetch(
    `${process.env.REACT_APP_API_URL}/${
      process.env.REACT_APP_API_VERSION
    }/projects/designs/${param ? `aggregate?${param}=${value}` : "aggregate"}`,
    {
      method: "GET",
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
        "Content-Type": "application/json",
      },
      signal: abortController?.signal,
    }
  )
    .then((response) => response.json())
    .then((result) => result)
    .catch((error) => {
      console.log("error", error);
    });
};

export const getProjectNoDesigns = () => {
  return fetch(
    `${process.env.REACT_APP_API_URL}/${process.env.REACT_APP_API_VERSION}/projects?designs=false`,
    {
      method: "GET",
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
        "Content-Type": "application/json",
      },
    }
  )
    .then((response) => response.json())
    .then((result) => result)
    .catch((error) => {
      console.log("error", error);
    });
};

export const getProjectPagination = (
  search: string,
  limit: number,
  offset: number,
  department?: string | number,
  abortController?: AbortController
) => {
  return fetch(
    `${process.env.REACT_APP_API_URL}/${
      process.env.REACT_APP_API_VERSION
    }/projects?designs=false&${
      search.length > 0 ? `search=${search}&` : ""
    }limit=${limit}&offset=${offset}${
      department && typeof department === "string"
        ? `&department_id=${department}`
        : ""
    }`,
    {
      method: "GET",
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
        "Content-Type": "application/json",
      },
      signal: abortController?.signal,
    }
  )
    .then((response) => response.json())
    .then((result) => result)
    .catch((error) => {
      console.log("error", error);
      return undefined;
    });
};

export const getProjectCount = (
  search: string,
  department?: string | number,
  abortController?: AbortController
) => {
  return fetch(
    `${process.env.REACT_APP_API_URL}/${
      process.env.REACT_APP_API_VERSION
    }/projects/counts?search=${search}${
      department && typeof department === "string"
        ? `&department_id=${department}`
        : ""
    }`,
    {
      method: "GET",
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
        "Content-Type": "application/json",
      },
      signal: abortController?.signal,
    }
  )
    .then((response) => response.json())
    .then((result) => result)
    .catch((error) => {
      console.log("error", error);
      return undefined;
    });
};

export const exportProjectToExcel = (
  start: string,
  end: string,
  department?: string | number,
  abortController?: AbortController
) => {
  return fetch(
    `${process.env.REACT_APP_API_URL}/${
      process.env.REACT_APP_API_VERSION
    }/projects?designs=false&created_at=${start},${end}${
      department && typeof department === "string"
        ? `&department_id=${department}`
        : ""
    }`,
    {
      method: "GET",
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
        "Content-Type": "application/json",
      },
      signal: abortController?.signal,
    }
  )
    .then((response) => response.json())
    .then((result) => result)
    .catch((error) => {
      console.log("error", error);
      return undefined;
    });
};

export const exportProject = (pid: string, input: any) => {
  return fetch(
    `${process.env.REACT_APP_API_URL}/${process.env.REACT_APP_API_VERSION}/projects/${pid}/exports`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
      body: JSON.stringify(input),
    }
  )
    .then((response) => response.json())
    .then((result) => result)
    .catch((error) => {
      console.log("error", error);
    });
};

export const saveProjectFile = (
  pid: string,
  input: { url: string; bbox: [number, number, number, number] }
) => {
  return fetch(
    `${process.env.REACT_APP_API_URL}/${process.env.REACT_APP_API_VERSION}/projects/${pid}/save-files`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
      body: JSON.stringify(input),
    }
  )
    .then((response) => response.json())
    .then((result) => result)
    .catch((error) => {
      console.log("error", error);
    });
};
